/*=========================================================================================
  File Name: actions.js
  Description: Vuex Store - actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

const actions = {

  // /////////////////////////////////////////////
  // COMPONENTS
  // /////////////////////////////////////////////

  // Vertical NavMenu
  updateVerticalNavMenuWidth({ commit }, width) {
    commit('UPDATE_VERTICAL_NAV_MENU_WIDTH', width)
  },

  // VxAutoSuggest
  updateStarredPage({ commit }, payload) {
    commit('UPDATE_STARRED_PAGE', payload)
  },

  // The Navbar
  arrangeStarredPagesLimited({ commit }, list) {
    commit('ARRANGE_STARRED_PAGES_LIMITED', list)
  },
  arrangeStarredPagesMore({ commit }, list) {
    commit('ARRANGE_STARRED_PAGES_MORE', list)
  },

  ///////////////////////////////////////////////
  // Auth
  ///////////////////////////////////////////////

  setLogoutTimer({
    commit
  }, expirationTime) {
    setTimeout(() => {
      commit('clearAuthData')
    }, expirationTime * 1000);
  },

  setDBUrl({
    commit
  }, url) {
    commit('setDBUrl', url);
  },

  setAuthDB({
    commit
  }, url) {
    commit('setAuthDB', url);
  },

  setuserRole({
    commit
  }, payload) {
    commit('setuserRole', payload);
  },

  // /////////////////////////////////////////////
  // UI
  // /////////////////////////////////////////////

  toggleContentOverlay({ commit }) {
    commit('TOGGLE_CONTENT_OVERLAY')
  },
  updateTheme({ commit }, val) {
    commit('UPDATE_THEME', val)
  },

  // /////////////////////////////////////////////
  // User/Account
  // /////////////////////////////////////////////

  updateUserInfo({ commit }, payload) {
    commit('UPDATE_USER_INFO', payload)
  },
  updateUserRole({ dispatch }, payload) {
    // Change client side
    payload.aclChangeRole(payload.userRole)

    // Make API call to server for changing role

    // Change userInfo in localStorage and store
    dispatch('updateUserInfo', { userRole: payload.userRole })
  },

  // language ////    
  setLanguage({
    commit
  }, val) {
    commit('setLanguage', val);
  },

  // Grid ////    
  setInbordersGrid({
    commit
  }, val) {
    commit('setInbordersGrid', val);
  },
  setVendorsGrid({
    commit
  }, val) {
    commit('setVendorsGrid', val);
  },
  setPosGrid({
    commit
  }, val) {
    commit('setPosGrid', val);
  },
  setProductTypesGrid({
    commit
  }, val) {
    commit('setProductTypesGrid', val);
  },
  setProductsGrid({
    commit
  }, val) {
    commit('setProductsGrid', val);
  },
  setBlocksTransGrid({
    commit
  }, val) {
    commit('setBlocksTransGrid', val);
  },
  setSlabsTransGrid({
    commit
  }, val) {
    commit('setSlabsTransGrid', val);
  },
  setLocationsGrid({
    commit
  }, val) {
    commit('setLocationsGrid', val);
  },
  setBlocksGrid({
    commit
  }, val) {
    commit('setBlocksGrid', val);
  },
  setInvoicesGrid({
    commit
  }, val) {
    commit('setInvoicesGrid', val);
  },
  setPosState({
    commit
  }, val) {
    commit('setPosState', val);
  },
  setInvoicesState({
    commit
  }, val) {
    commit('setInvoicesState', val);
  },
  setSlabsState({
    commit
  }, val) {
    commit('setSlabsState', val);
  },
  setSlabsGrid({
    commit
  }, val) {
    commit('setSlabsGrid', val);
  },
  setBlockscutGrid({
    commit
  }, val) {
    commit('setBlockscutGrid', val);
  },
  setBlockscutitemsGrid({
    commit
  }, val) {
    commit('setBlockscutitemsGrid', val);
  },
  setSlabscutitemsGrid({
    commit
  }, val) {
    commit('setSlabscutitemsGrid', val);
  },
  setBlockscutState({
    commit
  }, val) {
    commit('setBlockscutState', val);
  },
  setBlockscutitemsState({
    commit
  }, val) {
    commit('setBlockscutitemsState', val);
  },
  setSlabscutitemsState({
    commit
  }, val) {
    commit('setSlabscutitemsState', val);
  },
  setSlabscutGrid({
    commit
  }, val) {
    commit('setSlabscutGrid', val);
  },
  setSlabscutState({
    commit
  }, val) {
    commit('setSlabscutState', val);
  },
  setSlabsFinalsGrid({
    commit
  }, val) {
    commit('setSlabsFinalsGrid', val);
  },
  setSlabsFinalsTransGrid({
    commit
  }, val) {
    commit('setSlabsFinalsTransGrid', val);
  },
  setModesGrid({
    commit
  }, val) {
    commit('setModesGrid', val);
  },
  setTermsGrid({
    commit
  }, val) {
    commit('setTermsGrid', val);
  },
  setPortsGrid({
    commit
  }, val) {
    commit('setPortsGrid', val);
  },
  setCountrysGrid({
    commit
  }, val) {
    commit('setCountrysGrid', val);
  },
  setFinaccsGrid({
    commit
  }, val) {
    commit('setFinaccsGrid', val);
  },
  setFinaccsubsGrid({
    commit
  }, val) {
    commit('setFinaccsubsGrid', val);
  },
  setMinproduct({
    commit
  }, val) {
    commit('setMinproduct', val);
  },
  setCompanysTypesGrid({
    commit
  }, val) {
    commit('setCompanysTypesGrid', val);
  },
  setCompanysGrid({
    commit
  }, val) {
    commit('setCompanysGrid', val);
  },
  setBanksGrid({
    commit
  }, val) {
    commit('setBanksGrid', val);
  },
  setComid({
    commit
  }, val) {
    commit('setComid', val);
  },
  setRemarksGrid({
    commit
  }, val) {
    commit('setRemarksGrid', val);
  },
  setAssetsGrid({
    commit
  }, val) {
    commit('setAssetsGrid', val);
  },
  setStocksGrid({
    commit
  }, val) {
    commit('setStocksGrid', val);
  },
  setPosdepositsGrid({
    commit
  }, val) {
    commit('setPosdepositsGrid', val);
  },
  setPosinfor({
    commit
  }, val) {
    commit('setPosinfor', val);
  },
  setPoscreditinfor({
    commit
  }, val) {
    commit('setPoscreditinfor', val);
  },
  setBlockscutinfor({
    commit
  }, val) {
    commit('setBlockscutinfor', val);
  },
  setSlabscutinfor({
    commit
  }, val) {
    commit('setSlabscutinfor', val);
  },
  setPosData({
    commit
  }, val) {
    commit('setPosData', val);
  },

  setPosDataDel({
    commit
  }, val) {
    commit('setPosDataDel', val);
  },

  setPosDataDelState({
    commit
  }, val) {
    commit('setPosDataDelState', val);
  },

  setPosDataDelState2({
    commit
  }, val) {
    commit('setPosDataDelState2', val);
  },

  setRemarkData({
    commit
  }, val) {
    commit('setRemarkData', val);
  },
  setRemarkDataDel({
    commit
  }, val) {
    commit('setRemarkDataDel', val);
  },
  setSaveState({
    commit
  }, val) {
    commit('setSaveState', val);
  },
  inboundConfirm({
    commit
  }, val) {
    commit('inboundConfirm', val);
  },
  getSelectedPO({
    commit
  }, val) {
    commit('getSelectedPO', val);
  },
  callItemlistPO({
    commit
  }, val) {
    commit('callItemlistPO', val);
  },
  setSumState({
    commit
  }, val) {
    commit('setSumState', val);
  },
  SethotPoitemsHide({
    commit
  }, val) {
    commit('SethotPoitemsHide', val);
  },
  setSelectState({
    commit
  }, val) {
    commit('setSelectState', val);
  },
  setM3Exc({
    commit
  }, val) {
    commit('setM3Exc', val);
  },
  setM3Can({
    commit
  }, val) {
    commit('setM3Can', val);
  },
  setM3Rem({
    commit
  }, val) {
    commit('setM3Rem', val);
  },
  setM3RR({
    commit
  }, val) {
    commit('setM3RR', val);
  },
  setNblockName({
    commit
  }, val) {
    commit('setNblockName', val);
  },
  setNbRunning({
    commit
  }, val) {
    commit('setNbRunning', val);
  },
  setChkDup({
    commit
  }, val) {
    commit('setChkDup', val);
  },
  setSentBlock({
    commit
  }, val) {
    commit('setSentBlock', val);
  },
  setSentSlab({
    commit
  }, val) {
    commit('setSentSlab', val);
  },
  setSlabsFinalShow({
    commit
  }, val) {
    commit('setSlabsFinalShow', val);
  },
  setReportGrid({
    commit
  }, val) {
    commit('setReportGrid', val);
  },
}

export default actions
